import BolLayout from "../../templates/BolLayout/BolLayout";
import MoveWithUs from "../../templates/BOL/MoveWithUs/MoveWithUs";
import EstimateForService from "../../templates/BOL/EstimateForService/EstimateForService";
import DigitalSignature from "../../templates/BOL/DigitalSignature";
import Valuation from "../../templates/BOL/Valuation/Valuation";
import MoveDetail from "../../templates/BOL/MoveDetail/MoveDetail";
import ExtraOrdinary from "../../templates/BOL/ExtraOrdinary/ExtraOrdinary";
import MoveComfortably from "../../templates/BOL/MoveComfortably/MoveComfortably"
import TermsAndConditions from "../../templates/BOL/TermsAndConditions/TermsAndConditions";
import PickupAuthorization from "../../templates/BOL/PickupAuthorization/PickupAuthorization";
import BolLogin from '../../templates/Login'
import Authenticate from "../../templates/Authenticate"
import CustAckVerification from "../../templates/BOL-ACK/CustAckVerification"
import CustomerVerify from "../../templates/BOL-ACK/CustomerVerify"
import CustAckThankyou from "../../templates/BOL-ACK/CustAckThankyou"
import ValuationDetails from "../../templates/BOL/ValuationDetails/ValuationDetails";
import DownloadPdf from "../../templates/BOL-PDF/downloadPdf";
import ErrorLayout from "../../templates/ErrorLayout/ErrorLayout";
const templatesLibrary: any = {
    "BolLayout": BolLayout,
    "MoveWithUs": MoveWithUs,
    "EstimateForService": EstimateForService,
    "DigitalSignature": DigitalSignature,
    "MoveDetail": MoveDetail,
    "ExtraOrdinary": ExtraOrdinary,
    "Valuation": Valuation,
    "MoveComfortably": MoveComfortably,
    "PickupAuthorization": PickupAuthorization,
    "TermsAndConditions": TermsAndConditions,
    "BolLogin": BolLogin,
    "Authenticate": Authenticate,
    "CustAckVerification": CustAckVerification,
    "CustomerVerify": CustomerVerify,
    "CustAckThankyou": CustAckThankyou,
    "ValuationDetails": ValuationDetails,
    "DownloadPdf": DownloadPdf,
    "ErrorLayout": ErrorLayout
}
export default templatesLibrary;